import { NodeId } from 'web';
import { ChangeEvent, useCallback, useState } from 'react';
import { FlexCol } from '@/UI/styles';
import { NodeTextField } from '@/UI/NodeTextField/NodeTextField';
import { useUserWorkflowRole } from '@/state/workflow.state';
import { DynamicNode2 } from '@/components/Nodes/DynamicNode/DynamicNode2';
import { colorMap } from '@/colors';
import { TextData } from '@/types/node';
import { useTextView } from '@/components/Recipe/FlowContext';
import { getResizableDimensions } from '@/consts/node-ui.consts';

const STRING_NODE_RESIZABLE_DIMENSIONS = getResizableDimensions(76, 'small');

export function StringNode({ id, data }: { id: NodeId; data: TextData }) {
  const role = useUserWorkflowRole();
  const editable = data.isLocked !== true && role === 'editor';
  const view = useTextView(id);
  const { value } = data;

  const [hasFocus, setHasFocus] = useState(false);
  const handleFocus = useCallback(() => setHasFocus(true), []);
  const handleBlur = useCallback(() => setHasFocus(false), []);

  const handleChange = useCallback(
    (evt: ChangeEvent<HTMLInputElement>) => view.setText(evt.target.value, false),
    [view],
  );

  return (
    <DynamicNode2
      id={id}
      data={data}
      className="prompt"
      handleColor={colorMap.get('Yambo_Green')}
      isResizable
      resizableDimensions={STRING_NODE_RESIZABLE_DIMENSIONS}
    >
      <FlexCol className="nodrag" sx={{ flex: 1, minHeight: 0 }}>
        <NodeTextField
          className={hasFocus ? 'nodrag' : ''}
          disabled={!editable}
          value={value}
          placeholder="Text here..."
          multiline
          minHeight={data.height ? undefined : STRING_NODE_RESIZABLE_DIMENSIONS.defaultTextareaHeight}
          fullWidth
          size="small"
          onMouseDown={(event) => event.stopPropagation()}
          onFocus={handleFocus}
          onBlur={handleBlur}
          onChange={handleChange}
        />
      </FlexCol>
    </DynamicNode2>
  );
}
